import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Renderer } from "@unseenco/taxi";

gsap.registerPlugin(ScrollTrigger);

import GlobalHandler from "../global/global";
import AnimationHandler from "../global/animations";
import ScrollHandler, { lenis } from "../global/scroll";
import VideoHandler from "../global/video";
import PaddingHandler from "../global/padding";
import HeroHandler from "../partials/hero";
import CarouselHandler from "../partials/carousel";
import TabbarHandler from "../partials/tab_bar";
import TimelineIntroVersionHandler from "../partials/timeline_intro_version";
import TimelineHandler from "../partials/timeline";
import HeaderHandler from "../partials/header";
import AccordionHandler from "../partials/accordion";
import FiltersHandler from "../partials/filters";
import TabsHandler from "../partials/tabs";
import GlobalCtaHandler from "../partials/global_cta";
import FooterHandler from "../partials/footer";
import MarginOverlap from "../partials/margin_overlap";
import FormsHandler from "../partials/forms";
// import MapHandler from "../partials/map";
import MapHandler from "../partials/map";

const global = new GlobalHandler();
const animation = new AnimationHandler();
const scroll = new ScrollHandler();
const video = new VideoHandler();
const padding = new PaddingHandler();
const hero = new HeroHandler();
const carousel = new CarouselHandler();
const tabbar = new TabbarHandler();
const timelineIntroVersion = new TimelineIntroVersionHandler();
const timeline = new TimelineHandler();
const header = new HeaderHandler();
const accordion = new AccordionHandler();
const tabs = new TabsHandler();
const globalCta = new GlobalCtaHandler();
const footer = new FooterHandler();
const forms = new FormsHandler();
let filters = null;
// const map = new MapHandler();
const map = new MapHandler();

export default class RendererDefault extends Renderer {
    initialLoad() {
        this.onEnter(
            global.viewHeight(),
            scroll.init(),
        );
        this.onEnterCompleted(
            header.init(),
        );
    }
    onEnter() {
        lenis.scrollTo(0, { immediate: true });
        animation.animations();
        video.customPlayer();
        padding.init();
        tabbar.init();
        tabs.init();
        carousel.init();
        timelineIntroVersion.init();
        timeline.init();
        hero.init();
        accordion.init({
            firstTabActive: true,
            oneAtATime: true
        });
        globalCta.init();
        footer.init();
        forms.init();
        MarginOverlap.init();

        // Recreate filters instance on each page load to handle post type changes
        filters = new FiltersHandler();
        filters.init();
    }
    onEnterCompleted() {
        header.scroll();
        // map.init();
        map.init();
        // header.updateActiveLinks();
    }
    onLeave() {
        header.reset();
        forms.destroy();
        // header.closeMobileMenu();
    }
    onLeaveCompleted() {
        let triggers = ScrollTrigger.getAll();
        triggers.forEach((trigger) => {
            trigger.kill();
        });
    }
}